import React from 'react';
import styles from './Footer.module.css';
import { PhoneTelephone, EmailDown, Phone, ScanCode, LinkOne } from '@icon-park/react';

function Footer() {
  const footerLinks = {
    '关于我们': ['公司简介', '发展历程', '企业文化', '联系我们'],
    '产品服务': ['数字标签生成', '智能识别', '标签管理', 'API接口'],
    '帮助中心': ['使用指南', '常见问题', '视频教程', '技术支持'],
    '法律声明': ['服务条款', '隐私政策', '版权声明', '免责声明']
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerGrid}>
          <div className={styles.footerAbout}>
            <a
              className={styles.footerLogo}
              href="#"
              aria-label="访问数字标签内测官网"
            >
              <span className={styles.footerLogoText}>
                <strong>数字标签内测</strong>
                <small>Digital Label Beta</small>
              </span>
            </a>
            <p className={styles.footerDescription}>
              创新数字标签技术，引领食品行业未来。<br />
              为食品企业提供专业的数字标签生成与管理服务。
            </p>
            <div className={styles.footerContact}>
              <p>
                <PhoneTelephone theme="outline" size={16} fill="currentColor" strokeWidth={3} />
                咨询热线: <a href="tel:029-XXXXXXXX">029-XXXXXXXX</a>
              </p>
              <p>
                <EmailDown theme="outline" size={16} fill="currentColor" strokeWidth={3} />
                邮箱: <a href="mailto:service@digitallabel.com">service@digitallabel.com</a>
              </p>
              <p>
                <LinkOne theme="outline" size={16} fill="currentColor" strokeWidth={3} />
                官网: <a href="#">www.digitallabel.com</a>
              </p>
            </div>
          </div>
          
          {Object.entries(footerLinks).map(([title, links], index) => (
            <div key={index} className={styles.footerColumn}>
              <h4 className={styles.footerColumnTitle}>{title}</h4>
              <ul className={styles.footerLinks}>
                {links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a href="#">{link}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className={styles.footerBottom}>
          <div className={styles.footerQrCodes}>
            <div className={styles.qrCodeItem}>
              <div className={styles.qrPlaceholder}>
                <ScanCode theme="outline" size={28} fill="#fff" strokeWidth={3} />
              </div>
              <span>微信公众号</span>
            </div>
            <div className={styles.qrCodeItem}>
              <div className={styles.qrPlaceholder}>
                <Phone theme="outline" size={28} fill="#fff" strokeWidth={3} />
              </div>
              <span>APP下载</span>
            </div>
          </div>
          <div className={styles.footerCopyright}>
            <p>© 2025 数字标签内测 All Rights Reserved.</p>

          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
